import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { allProducts } from '../mock';

export const Products = () => {
  const [selectedLetter, setSelectedLetter] = useState('all');

  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  const filteredProducts = allProducts.filter((product) => {
    const matchesLetter = 
      selectedLetter === 'all' || 
      product.charAt(0).toUpperCase() === selectedLetter;
    return matchesLetter;
  });

  // Group products by first letter
  const groupedProducts = filteredProducts.reduce((acc, product) => {
    const firstLetter = product.charAt(0).toUpperCase();
    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(product);
    return acc;
  }, {});

  const sortedLetters = Object.keys(groupedProducts).sort();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6">
              Our Products
            </h1>
            <p className="text-xl text-slate-600">
              Comprehensive selection of high-quality chemicals for diverse industrial applications
            </p>
          </div>
        </div>
      </section>

      {/* A-Z Filter Section */}
      <section className="py-8 px-4 bg-white border-b border-slate-200 sticky top-20 z-40">
        <div className="container mx-auto">
          <div className="flex flex-wrap justify-center gap-2">
            <Button
              size="sm"
              variant={selectedLetter === 'all' ? 'default' : 'outline'}
              onClick={() => setSelectedLetter('all')}
              className={`min-w-[40px] ${selectedLetter === 'all' ? 'bg-slate-900 hover:bg-slate-800' : 'hover:bg-slate-100'}`}
            >
              All
            </Button>
            {alphabet.map((letter) => (
              <Button
                key={letter}
                size="sm"
                variant={selectedLetter === letter ? 'default' : 'outline'}
                onClick={() => setSelectedLetter(letter)}
                className={`min-w-[40px] ${selectedLetter === letter ? 'bg-slate-900 hover:bg-slate-800' : 'hover:bg-slate-100'}`}
              >
                {letter}
              </Button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto">
          {filteredProducts.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-xl text-slate-600">No products found.</p>
            </div>
          ) : (
            <div className="space-y-12">
              {sortedLetters.map((letter) => (
                <div key={letter} id={`letter-${letter}`}>
                  <div className="flex items-center mb-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-slate-700 to-slate-900 rounded-xl flex items-center justify-center mr-4">
                      <span className="text-3xl font-bold text-white">{letter}</span>
                    </div>
                    <div className="flex-1 h-px bg-slate-200"></div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {groupedProducts[letter].map((product, index) => (
                      <Card
                        key={index}
                        className="border-2 border-slate-100 hover:border-orange-200 hover:shadow-lg transition-all duration-300 group cursor-pointer"
                      >
                        <CardContent className="p-6">
                          <p className="text-slate-900 font-medium group-hover:text-orange-600 transition-colors">
                            {product}
                          </p>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-slate-50">
        <div className="container mx-auto">
          <Card className="border-2 border-slate-200 bg-gradient-to-br from-slate-900 to-slate-800 text-white">
            <CardContent className="p-12 text-center">
              <h2 className="text-4xl font-bold mb-4">
                Can't Find What You're Looking For?
              </h2>
              <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
                We have access to a wide network of suppliers. Contact us with your requirements and we'll source it for you.
              </p>
              <Button
                size="lg"
                className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-6 text-lg h-auto"
              >
                Contact Our Team
              </Button>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};